import { useRef } from "react";

import { IconButton, Tooltip } from "@mui/material";
import { IoMdAdd } from "react-icons/io";
import { IoSettingsOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

import { useAccount } from "../../../../../hooks/useAccount";
import { AddBusyTimeModal, TAddBusyTimeModalRef } from "./AddBusyTimeModal";
import { Calendar } from "./Calendar";
import { ERole } from "../../../../../@types";

import "./scheduler.scss";

export function Scheduler() {
	const addBusyTimeModalRef = useRef<TAddBusyTimeModalRef | null>(null);
	const { account } = useAccount();

	return (
		<div className="right-column-content-container">
			<div className="scheduler-container">
				{account?.role === ERole.INSTRUCTOR && (
					<div className="calendar-setting-button-group">
						<Tooltip title="Block time">
							<IconButton
								className="icon-button"
								onClick={() => {
									addBusyTimeModalRef.current?.open();
								}}>
								<IoMdAdd />
							</IconButton>
						</Tooltip>
						<Link to="/training/availability">
							<IconButton className="icon-button">
								<IoSettingsOutline />
							</IconButton>
						</Link>
					</div>
				)}
				<Calendar
					onCellDoubleClick={(startDate, endDate) => {
						if (account?.role !== ERole.INSTRUCTOR) {
							return;
						}
						addBusyTimeModalRef.current?.open({
							startDate,
							startTime: startDate,
							endTime: endDate,
						});
					}}
				/>
				<AddBusyTimeModal ref={addBusyTimeModalRef} />
			</div>
		</div>
	);
}
